export default {"src":"/_next/static/media/gamestop-asurion-logo.62611407.svg","height":40,"width":211,"blurWidth":0,"blurHeight":0};